module.exports = __webpack_public_path__ + "static/media/ECDC_twodash.a9678376.svg";